import React from 'react'

import { Box } from 'components/layout/Box/Box'
import { Table } from 'components/shared/Table/Table'
import type { TableCellProps } from 'components/shared/Table/types'

import styles from './TextCell.module.scss'

type TextCellProps = Pick<
  TableCellProps,
  'className' | 'maxWidth' | 'hasIncreasedHeight'
> & {
  justify?: string
  text?: React.ReactNode
}

export const TextCell = ({
  className,
  justify = 'center',
  text,
  maxWidth,
  hasIncreasedHeight,
}: TextCellProps) => (
  <Table.Cell type="body" {...{ className, maxWidth, hasIncreasedHeight }}>
    <Box
      align="center"
      className={styles.content}
      tagName="span"
      {...{ justify }}
    >
      {text}
    </Box>
  </Table.Cell>
)
